import React from "react";
import { Toaster as SonnerToaster } from "sonner";

export const DEFAULT_TOAST_DURATION_MS = 3000;

export const Toaster: React.FC = () => (
  <SonnerToaster
    position="top-right"
    duration={DEFAULT_TOAST_DURATION_MS}
    swipeDirections={["right"]}
    offset={16}
    mobileOffset={16}
    gap={8}
    toastOptions={{ className: "w-(--width)" }}
  />
);
